module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Light.fb2a086.eot";